import { Button, Input, Modal, ModalDialog, Option, Radio, RadioGroup, Select } from "@mui/joy";
import React, { useEffect, useRef, useState } from "react";
import ModalHeaderForMoney from "./modalheader";
import { getFetch, postFetch } from "../../../../../fetch/fetch";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import koLocale from 'date-fns/locale/ko'
import { DateRange, StaticDateRangePicker } from "@mui/x-date-pickers-pro";
import { Box, TextField } from "@mui/material";
import { calcRegisterFeeByLocation, makeGroupedFeeLines } from "../functions/newcalcregisterfuncs";
import { englishLocationToKorean, koreanLocationToEnglish } from "../../../../../data/locationFuntion";
import { AttachMoney, Edit } from "@mui/icons-material";
import { set } from "lodash";
import totalLocationData from "../../../../../data/locationdata";
import { dateToDateString } from "../../etc/etcfunctions";


const NewPayLinkModal = (props: any) => {



    const [loading, setLoading] = useState<boolean>(false);
    const [selectedStudentsLocations, setSelectedStudentsLocations] = useState<string>("");
    const [selectedStudentEnglishLocations, setSelectedStudentEnglishLocations] = useState<string[]>([]);
    const [value, setValue] = React.useState<DateRange<Date>>([null, null]);
    const [info, setInfo] = useState<any>();
    const [registerInfo, setRegisterInfo] = useState<any>();
    const [finalResult, setFinalResult] = useState<any>();
    const [postData, setPostData] = useState<any>([]);
    const [discount, setDiscount] = useState<number>(0);
    const [appliedDiscount, setAppliedDiscount] = useState<number>(0);
    const [gender, setGender] = useState<string>("");

    const [location, setLocation] = useState<string>("");
    const [seat, setSeat] = useState<number>();

    const [modalOpen, setModalOpen] = useState<boolean>(false);
    const [modalOpen2, setModalOpen2] = useState<boolean>(false);

    const [name, setName] = useState<string>("");
    const [phoneNumber, setPhoneNumber] = useState<string>("010");

    const inputRef = useRef<any>(null);
    const inputRef2 = useRef<any>(null);

    const [disabled, setDisabled] = useState(true);

    const [dueHours, setDueHours] = useState<number>(5);

    const [customPrice, setCustomPrice] = useState<number>(0);
    const [appliedCustomPrice, setAppliedCustomPrice] = useState<number>(0);

    useEffect(() => {

        if (!props.open) {
            setAppliedDiscount(0);
            setDiscount(0);
        }

    }, [props.open]);

    const handleClose = () => {
        setModalOpen(false);
    }

    const handleClose2 = () => {
        setModalOpen2(false);
    }


    useEffect(() => {
        if (props.open) {

        }
    }, [props.open]);

    useEffect(() => {
        if (!props.open) {
            setSelectedStudentsLocations("");
            setValue([null, null]);
            setFinalResult(undefined);
            setPostData([]);
            setRegisterInfo(undefined);
            setInfo(undefined);
            setLoading(false);
            setLocation("");
            setSeat(undefined);
            setName("");
            setPhoneNumber("010");
            setAppliedDiscount(0);
            setDiscount(0);
            setDisabled(true);
            setDueHours(5);
            setGender("");
        }
    }, [props.open]);

    const formatKoreanDate = (date: Date) => {
        const days = ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"];

        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const dayOfWeek = days[date.getDay()];

        return `${year}년 ${month}월 ${day}일(${dayOfWeek})`;
    };

    const makeLink = async () => {

        try {

            if (!location || !value[0] || !value[1]) {
                return;
            }

            if (!finalResult) {
                return;
            }

            if(!gender){
                return;
            }

            setLoading(true);


            // startDate.setHours(0, 0, 0, 0);
            // endDate.setHours(23, 59, 59, 999);

            // const startDateTime = startDate.getTime();
            // const endDateTime = endDate.getTime();

            const startDate = value[0];
            const endDate = value[1];

            startDate.setHours(0, 0, 0, 0);
            endDate.setHours(23, 59, 59, 999);

            const startDateTime = startDate.getTime();
            const endDateTime = endDate.getTime();

            const data = {
                location: location,
                seat: seat,
                startDateTime: startDateTime,
                endDateTime: endDateTime,
                price: finalResult,
                appliedDiscount: appliedDiscount,
                phoneNumber: phoneNumber.replace(/\D/g, ''),
                name: name,
                dueHours: dueHours,
                gender
            }

            console.log(data);

            const result: any = await postFetch("/dashboard/payments/managepayments/createpaylink", data);

            setLoading(false);

            if (result.message === "success") {
                props.notify1();
                props.handleClose();
                props.setUpdate(Math.random());
            }

            return;

        } catch (e) {
            console.log(e);
        }
    }

    useEffect(() => {

        if (!value[0] || !value[1]) {
            return;
        }

        const result = calcRegisterFeeByLocation({
            registerPayInfo: props.registerPayInfo,
            selectedRange: [value[0], value[1]],
            appliedDiscount
        })

        console.log(result);
        setRegisterInfo(result.result);

    }, [value[0], value[1], appliedDiscount]);

    useEffect(() => {

        if (!registerInfo || !location) {
            return;
        }

        const result = (registerInfo && registerInfo[location]) ? registerInfo[location] : 0;

        console.log(result);

        if(!appliedCustomPrice || appliedCustomPrice === 0){
            setFinalResult(result);
        } else {
            setFinalResult(appliedCustomPrice);
        }

    }, [registerInfo, appliedDiscount, location, appliedCustomPrice]);

    useEffect(() => {

        //휴대폰 번호가 대시 제외하고 11자리인지 확인
        const digitsOnly = phoneNumber ? phoneNumber.replace(/\D/g, '') : '';

        if (digitsOnly.length === 11 && name.trim().length > 0 && location && value[0] && value[1] && finalResult && gender) {
            setDisabled(false);
        } else {
            setDisabled(true);
        }

    }, [phoneNumber, name, location, value, finalResult, gender]);

    const controlChange = (raw: string) => {

        // 1. 숫자만 남기기
        let digits = raw.replace(/\D/g, "");

        // 2. 앞 3자리는 무조건 010 유지
        if (!digits.startsWith("010")) {
            // 지우려고 해서 0, 01 이런 상태가 되면 그냥 010으로 고정
            if (digits.length <= 3) {
                digits = "010";
            } else {
                // 앞자리를 바꾸려 해도 010으로 강제
                digits = "010" + digits.slice(3);
            }
        }

        // 안전장치: 최소 010은 유지
        if (digits.length < 3) {
            digits = "010";
        }

        // 3. 총 숫자 갯수 제한 (010-1234-5678 => 11자리)
        if (digits.length > 11) {
            digits = digits.slice(0, 11);
        }

        // 4. 자리수에 따라 하이픈 붙이기/빼기
        let formatted = "";
        if (digits.length <= 3) {
            // 010
            formatted = digits;
        } else if (digits.length <= 7) {
            // 010-1 ~ 010-1234
            formatted = digits.slice(0, 3) + "-" + digits.slice(3);
        } else {
            // 010-1234-5 ~ 010-1234-5678
            formatted =
                digits.slice(0, 3) + "-" + digits.slice(3, 7) + "-" + digits.slice(7);
        }

        setPhoneNumber(formatted);

        if (digits.length === 11) {
            inputRef.current?.blur();
        }
    };



    return (
        <Modal
            open={props.open}
            onClose={props.handleClose}
            slotProps={{
                backdrop: {
                    sx: {
                        backdropFilter: "none",
                        backgroundColor: "transparent",
                    },
                },
            }}
        >
            <ModalDialog
                sx={{
                    width: 650,
                    maxWidth: 650,
                    boxSizing: "border-box",   // ✅ 핵심
                    p: 2,                      // (원하는 패딩 값으로 통일)
                    maxHeight: "90vh",
                    overflowY: "auto",
                    overflowX: "hidden",
                    scrollbarWidth: "none",
                    msOverflowStyle: "none",
                    "&::-webkit-scrollbar": { display: "none" },
                }}
            >
                <div style={{
                    width: "100%",
                    boxSizing: "border-box",
                }}>
                    <div style={{
                        fontFamily: "Apple_B",
                        fontSize: "20px",
                        marginBottom: "18px"
                    }}>
                        신규 결제링크 전송하기
                    </div>
                    <div>
                        <div style={{
                            fontFamily: "Apple_SB",
                            marginBottom: "10px",
                            fontSize: "17px"
                        }}>
                            이름*
                        </div>
                        <div>
                            <Input value={name} onChange={(e) => {
                                setName(e.target.value);
                            }} placeholder="이름을 입력해주세요" style={{ width: "610px", marginTop: "6px" }} />
                        </div>
                        <div style={{
                            fontFamily: "Apple_SB",
                            marginBottom: "10px",
                            fontSize: "17px",
                            marginTop: "24px"
                        }}>
                            학생 성별*
                        </div>
                        <div>
                            <RadioGroup
                            value={gender}
                            onChange={(e) => setGender(e.target.value)}
                            orientation="horizontal"
                            >
                                <Radio value="male" label="남학생" />
                                <Radio value="female" label="여학생" style={{ marginLeft: "20px" }} />
                            </RadioGroup>
                        </div>
                        <div style={{
                            fontFamily: "Apple_SB",
                            marginBottom: "10px",
                            fontSize: "17px",
                            marginTop: "24px"
                        }}>
                            전송 전화번호*
                        </div>
                        <div>
                            <Input value={phoneNumber} onChange={(e) => {
                                controlChange(e.target.value);
                            }} placeholder="전화번호를 입력해주세요" style={{ width: "610px", marginTop: "6px" }}
                                ref={inputRef}
                            />
                        </div>
                        <div style={{
                            fontFamily: "Apple_SB",
                            marginBottom: "10px",
                            fontSize: "17px",
                            marginTop: "24px"
                        }}>
                            지점 선택*
                        </div>
                        <div>
                            <Select placeholder="지점을 선택해주세요"
                                value={location}
                                onChange={(e: any, newValue: any) => {
                                    console.log(newValue);
                                    setLocation(newValue)
                                }}
                                style={{ width: "610px", marginTop: "6px" }}
                            >
                                {
                                    totalLocationData.map((data, index: number) => {

                                        if (!data.academy.includes("sunbae") && !data.academy.includes("bundangsunbae")) {
                                            return;
                                        }

                                        if (data.english === "total") {
                                            return;
                                        }

                                        return (
                                            <Option key={index} value={data.english}>
                                                {data.korean}
                                            </Option>
                                        )
                                    })
                                }
                            </Select>
                        </div>
                    </div>
                    <div>
                        <div style={{
                            fontFamily: "Apple_SB",
                            marginBottom: "10px",
                            marginTop: "24px",
                            fontSize: "17px"
                        }}>
                            자리 선택
                        </div>
                        <div>
                            <Select placeholder="자리를 선택해주세요"
                                value={seat}
                                onChange={(e: any, newValue: any) => {
                                    console.log(newValue);
                                    setSeat(newValue)
                                }}
                                style={{ width: "610px", marginTop: "6px" }}
                            >
                                {
                                    new Array(500).fill(0).map((_, index) => (
                                        <Option key={index} value={index + 1}>
                                            {index + 1}번 자리
                                        </Option>
                                    ))
                                }
                            </Select>
                        </div>
                        <div style={{
                            fontFamily: "Apple_SB",
                            marginBottom: "10px",
                            fontSize: "17px",
                            marginTop: "24px"
                        }}>
                            결제 만료 시간 설정(H)
                        </div>
                        <div>
                            <Input value={dueHours} onChange={(e) => {
                                setDueHours(Number(e.target.value));
                            }} placeholder="결제 만료 시간을 입력해주세요 (시간 단위)" style={{ width: "610px", marginTop: "6px" }}
                                type="number"
                                ref={inputRef2}
                            />
                        </div>
                    </div>
                    <div style={{
                        marginTop: "24px"
                    }}>
                        <div style={{
                            fontFamily: "Apple_SB",
                            marginBottom: "10px",
                            fontSize: "17px"
                        }}>
                            등록 날짜 설정*
                        </div>
                        <div>
                            <LocalizationProvider locale={koLocale} dateAdapter={AdapterDateFns}>
                                <StaticDateRangePicker
                                    value={value}
                                    onChange={(value) => {
                                        console.log(value);
                                        setValue(value);
                                    }}
                                    displayStaticWrapperAs="desktop"
                                    renderInput={(startProps: any, endProps: any) => (
                                        <React.Fragment>
                                            {/* <TextField {...startProps} /> */}
                                            <Box sx={{ mx: 2 }}> to </Box>
                                            {/* <TextField {...endProps} /> */}
                                        </React.Fragment>
                                    )}
                                    shouldDisableDate={
                                        (day, position) => {
                                            // 시작일일 때만 일요일 비활성화
                                            if (position === 'start') {
                                                return day.getDay() === 0; // 일요일
                                            }
                                            return false; // 종료일은 허용
                                        }
                                    }
                                />
                            </LocalizationProvider>
                        </div>
                    </div>
                    {
                        (value[0] && value[1]) ?
                            <>
                                <div style={{
                                    marginTop: "24px"
                                }}>
                                    <div style={{
                                        fontFamily: "Apple_SB",
                                        marginBottom: "10px",
                                        fontSize: "17px"
                                    }}>
                                        등록 예정 기간
                                    </div>
                                    <div>
                                        {formatKoreanDate(value[0])}
                                        {" ~ "}
                                        {formatKoreanDate(value[1])}
                                    </div>
                                </div>
                                <div style={{
                                    marginTop: "24px"
                                }}>
                                    <div style={{
                                        fontFamily: "Apple_SB",
                                        marginBottom: "10px",
                                        fontSize: "17px",
                                        display: "flex",
                                        alignItems: "center"
                                    }}>
                                        등록 예정 비용
                                        <span style={{
                                            display: "inline-flex", alignItems: "center"
                                        }}
                                            onClick={() => {
                                                setModalOpen(true);
                                            }}
                                        >
                                            <Edit fontSize="small" style={{ marginLeft: "8px", cursor: "pointer" }} />
                                        </span>
                                        {/* 최종금액 설정: 결제 관리 직원 모두 사용 가능 (todoistApiKey 가드 제거) */}
                                        <span style={{
                                            display: "inline-flex", alignItems: "center", marginLeft: '12px'
                                        }}
                                            onClick={() => {
                                                setModalOpen2(true);
                                            }}
                                        >
                                            <AttachMoney fontSize="small" style={{ marginLeft: "8px", cursor: "pointer" }} />
                                        </span>
                                    </div>
                                    <div>
                                        {finalResult?.toLocaleString()}원
                                    </div>
                                </div>
                            </>
                            :
                            ""
                    }

                    <div style={{
                        marginTop: "32px",
                        paddingBottom : "16px"
                    }}>
                        <Button
                            fullWidth
                            variant="solid"
                            color="primary"
                            onClick={makeLink}
                            disabled={disabled}
                            loading={loading}
                            size="lg"
                        >
                            링크 발송하기
                        </Button>
                    </div>
                </div>

                <Modal
                    open={modalOpen}
                    onClose={handleClose}
                >
                    <ModalDialog>
                        <div style={{
                            width: "300px"
                        }}>
                            <div style={{
                                fontFamily: "Apple_SB",
                                fontSize: "20px",
                                marginBottom: "12px"
                            }}>
                                할인률 설정
                            </div>
                            <div>
                                <Input
                                    fullWidth
                                    type="number"
                                    value={discount}
                                    onChange={(e) => {
                                        setDiscount(+e.target.value);
                                    }}
                                    endDecorator={<span>%</span>}
                                />
                            </div>
                            <div style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                marginTop: "24px"
                            }}>
                                <Button
                                    variant="solid"
                                    onClick={() => {
                                        setAppliedDiscount(discount);
                                        setModalOpen(false);
                                    }}
                                >
                                    적용시키기
                                </Button>
                            </div>
                        </div>
                    </ModalDialog>
                </Modal>


                <Modal
                    open={modalOpen2}
                    onClose={handleClose2}
                >
                    <ModalDialog>
                        <div style={{
                            width: "300px"
                        }}>
                            <div style={{
                                fontFamily: "Apple_SB",
                                fontSize: "20px",
                                marginBottom: "12px"
                            }}>
                                최종금액 설정
                            </div>
                            <div>
                                <Input
                                    fullWidth
                                    type="number"
                                    value={customPrice}
                                    onChange={(e) => {
                                        setCustomPrice(+e.target.value);
                                    }}
                                    endDecorator={<span>원</span>}
                                />
                            </div>
                            <div style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                marginTop: "24px"
                            }}>
                                <Button
                                    variant="solid"
                                    onClick={() => {
                                        setAppliedCustomPrice(customPrice);
                                        setModalOpen2(false);
                                    }}
                                >
                                    적용시키기
                                </Button>
                            </div>
                        </div>
                    </ModalDialog>
                </Modal>

                


            </ModalDialog>
        </Modal>
    )
}

export default NewPayLinkModal;